module.exports = __webpack_public_path__ + "lk.eaf0209a5f4ca32dcd5f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/lk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/lk.svg
// module chunks = styles